import React from 'react';
import '../styles/home.css';

const Home = () => (
  <div className="home">
    <h1 className="home-title">Welcome to our page!</h1>
    <div className="home-content">
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam
        voluptatum, voluptate, quibusdam, quas, voluptatibus quos dolorum
        officiis voluptatem consequatur fugit quod? Quisquam voluptatum,
        voluptate, quibusdam, quas, voluptatibus quos dolorum officiis
        voluptatem consequatur fugit qu
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam
        voluptatum, voluptate, quibusdam, quas, voluptatibus quos dolorum
        officiis voluptatem consequatur fugit quod? Quisquam voluptatum,
        voluptate, quibusdam, quas, voluptatibus quos dolorum officiis
        voluptatem consequatur fugit qu
      </p>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam
        voluptatum, voluptate, quibusdam, quas, voluptatibus quos dolorum
        officiis voluptatem consequatur fugit quod? Quisquam voluptatum,
        voluptate, quibusdam, quas, voluptatibus quos dolorum officiis
        voluptatem consequatur fugit qu
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam
        voluptatum, voluptate, quibusdam, quas, voluptatibus quos dolorum
        officiis voluptatem consequatur fugit quod? Quisquam voluptatum,
        voluptate, quibusdam, quas, voluptatibus quos dolorum officiis
        voluptatem consequatur fugit qu
      </p>
    </div>
  </div>
);

export default Home;
